import { Component, EventEmitter, inject, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DamageReport } from '../../core/models/damagereport';
import { DamageReportService } from '../../core/services/backend/damage-report.service';
import { ScrollViewWithBottomBarComponent } from '~/app/shared/components/scroll-view-with-bottom-bar.component';
import { AppButtonComponent } from '~/app/shared/components/app-button.component';
import { DxValidationGroupComponent, DxValidationGroupModule } from 'devextreme-angular/ui/validation-group';
import { DxTextBoxModule } from 'devextreme-angular/ui/text-box';
import { DxValidatorModule } from 'devextreme-angular/ui/validator';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxTextAreaModule } from 'devextreme-angular/ui/text-area';
import { DxSelectBoxModule } from 'devextreme-angular/ui/select-box';

@Component({
  selector: 'app-damage-report',
  templateUrl: './damage-report.component.html',
  imports: [
    ScrollViewWithBottomBarComponent,
    DxValidationGroupModule,
    DxTextBoxModule,
    DxValidatorModule,
    TranslateModule,
    DxButtonModule,
    AppButtonComponent,
    DxTextAreaModule,
    DxSelectBoxModule,
  ],
})
export class DamageReportComponent implements OnInit {
  @ViewChild('damageReportVG', { static: false }) public damageReportVG?: DxValidationGroupComponent;

  @Output() public closeDamageReport = new EventEmitter();
  public formData = new DamageReport();

  public availableLocations = [
    {
      value: 'arbeitsplatz',
    },
    {
      value: 'autowaschanlage',
    },
    {
      value: 'demoraum1ug',
    },
    {
      value: 'fitnessumkleideruheraum',
    },
    {
      value: 'garage',
    },
    {
      value: 'reinholdwuerthsaal',
    },
    {
      value: 'restaurant',
    },
    {
      value: 'sitzungszimmer',
    },
    {
      value: 'wcanlagen',
    },
  ];

  public translateService = inject(TranslateService);
  public damageReportService = inject(DamageReportService);

  public ngOnInit() {
    this.reset();
  }

  public send() {
    if (this.damageReportVG) {
      if (this.damageReportVG.instance.validate().isValid) {
        this.damageReportService.post(this.formData).subscribe(() => {
          this.closeDamageReport.emit();
          this.reset();
        });
      }
    }
  }

  public close() {
    this.reset();
    this.closeDamageReport.emit();
  }

  public reset() {
    this.formData = new DamageReport();
  }
}
